import { useStyletron } from "baseui";
import { Block } from "baseui/block";
import { Button } from "baseui/button";
import { ButtonGroup, MODE } from "baseui/button-group";
import { LabelLarge, LabelMedium, LabelSmall, LabelXSmall, ParagraphMedium, ParagraphXSmall } from "baseui/typography";
import { useMemo, useState } from "react";
import { VscDebugLineByLine } from "react-icons/vsc";
import { LoadingView } from "../../../components";
import { useGetMappingsTemplatesQuery, MappingTemplate, BACnetVendorId } from "../../../services/mapping/bacnet";

export interface MappingTemplatesViewProps {
    edgeDeviceId: string,
    bacnetdeviceid: number,
    onTemplateSelected: any,
    vendorId: number
}
export const MappingTemplatesView = (props: MappingTemplatesViewProps) => {
    const [css] = useStyletron();

    const { data, isLoading, isError, error, isSuccess } = useGetMappingsTemplatesQuery({ edgeDeviceId: props.edgeDeviceId, deviceId: props.bacnetdeviceid });
    const [selected, setSelected] = useState<any>(-1);

    function onSelectionChanged(item) {
        setSelected(item);
        props.onTemplateSelected(item);
    }
    // filter by vendor
    const filtered = useMemo(() => {
        return props.vendorId === BACnetVendorId.ANY ? data : data?.filter((item: MappingTemplate, index: number) => item.vendors.includes( BACnetVendorId.ANY) || item.vendors.includes(props.vendorId) )
    }, [data])
   

    return (
        <>
            <LoadingView isLoading={isLoading} error={error} isSucess={isSuccess}>
                <div className={css({
                    overflowY: "auto",
                    width: "auto",
                    height: 'calc(90vh - 470px)'
                })}>
                    <Block width='100%' display='flex' flexDirection='row' flexWrap alignContent='flex-start' gridGap='5px'>
                        {filtered?.map((item: any, index: number) => (
                            <Button isSelected={selected === item} onClick={() => { onSelectionChanged(item) }} kind="secondary" overrides={{
                                BaseButton: {
                                    style: ({ $theme }) => ({
                                        width: '250px'
                                    })
                                }
                            }}>
                                <Block display='flex' flexDirection='column' gridGap='0px' alignItems='center'>
                                    <LabelSmall color='unset' marginTop='5px'>{item.name.replace("Add", "").replace("Template", "")}</LabelSmall>
                                    <ParagraphXSmall color='unset' className={css({
                                        maxHeight: '50px'
                                    })}>{item.description}</ParagraphXSmall>
                                </Block>
                            </Button>
                        ))}
                    </Block>
                </div>
            </LoadingView>
        </>
    );
}

var groupBy = function(xs, key) {
    return xs.reduce(function(rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  };